import { useCallback, useEffect, useRef, useState } from 'react'
import { THREAD_MENU_ACTION } from './threadRowMenuConfig.js'

export function useThreadListRowRename({ title, thread, onRenameThread }) {
  const [isEditingTitle, setIsEditingTitle] = useState(false)
  const [draftTitle, setDraftTitle] = useState(title)
  const titleInputRef = useRef(null)

  useEffect(() => {
    if (!isEditingTitle) setDraftTitle(title)
  }, [title, isEditingTitle])

  useEffect(() => {
    if (isEditingTitle) titleInputRef.current?.focus()
  }, [isEditingTitle])

  const commitRename = useCallback(() => {
    setIsEditingTitle(false)
    const trimmed = draftTitle.trim()
    if (!trimmed) {
      setDraftTitle(title)
      return
    }
    if (trimmed !== title && thread) onRenameThread?.(thread, trimmed)
  }, [draftTitle, onRenameThread, thread, title])

  const cancelRename = useCallback(() => {
    setDraftTitle(title)
    setIsEditingTitle(false)
  }, [title])

  const handleMenuItemSelect = useCallback(
    (id, closeMenu) => {
      if (id !== THREAD_MENU_ACTION.RENAME) return
      closeMenu?.()
      setDraftTitle(title)
      setIsEditingTitle(true)
      return false
    },
    [title],
  )

  return {
    isEditingTitle,
    draftTitle,
    setDraftTitle,
    titleInputRef,
    commitRename,
    cancelRename,
    handleMenuItemSelect,
  }
}
